<template>
  <div class="bg-gray-400 w-full">
    <sprite-view v-if='!enableGallery' class='h-16 w-16' :sprite='vfg.schema.data.component' />
    <div v-else class="grow propertyform-sprite-gallery" >
      <div class="h-12 w-full flex flex-none justify-center bg-white py-2 border-box border-t bg-gray-200">
        <pbc-toggle-button v-model='isImageMode'>
          <h3 class="mx-3 my-1 font-semibold text-sm leading-snug tracking-wide">
            Image
          </h3>
        </pbc-toggle-button>
        <pbc-toggle-button v-model='isAnimationMode'>
          <h3 class="mx-3 my-1 font-semibold text-sm leading-snug tracking-wide">
            Animation
          </h3>
        </pbc-toggle-button>
      </div>

      <choose-or-upload-image v-if='isImageMode'
                              game-id='chezzer'
                              @select="select"
                              @upload-image='onUploadImage'
                              :uploaded-images='uploadedImages' />
      <choose-or-upload-animations v-else 
                                   game-id='chezzer'
                                   :component='component'
                                   @select="select" 
                                   @upload-image='onUploadImage'
                                   :uploaded-images='uploadedImages' />
    </div>
  </div>
</template>
<script>
import SpriteView from '@edit/atoms/SpriteView.vue';
import ChooseOrUploadImage from '@ui/organisms/ChooseOrUploadImage.vue';
import ChooseOrUploadAnimations from '@ui/organisms/ChooseOrUploadAnimations.vue';
import { abstractField } from "vue-form-generator";

export default {
  mixins: [ abstractField ],
  inject:['api'],
  data() {
    const enableGallery = this.schema.enableGallery;
    const gamedata = this.vfg.schema.data.partutil.gamedata.gamedata;
    if (typeof(gamedata.uploadedImages) === 'undefined') {
      this.$set(gamedata, 'uploadedImages', []);
    }
    const uploadedImages = gamedata.uploadedImages;
    return {
      enableGallery,
      uploadedImages
    }
  },
  mounted() {
  },
  methods: {
    select({id,...rest}) {
      console.log('select',id,rest);
      console.log('aaaaaaaaa', this.vfg.schema);
      console.log('aaaaaaaaa', this.vfg.schema.data);
      if (this.enableGallery) {
        if (rest.spritesheet) {
          const {component} = this.vfg.schema.data;
          this.$set(component, 'atlas', rest.spritesheet);
          this.$set(component, 'texture', rest.image.name);
          this.value = rest.image.name;
        } else {
          const {component} = this.vfg.schema.data;
          this.$set(component, 'atlas', undefined);
          this.$set(component, 'texture', undefined);
          this.value = id;
        }
      }
    },
    onUploadImage(image) {
      const {partutil} = this.vfg.schema.data;
      const gamedata = partutil.gamedata.gamedata;
      if (typeof(gamedata.uploadedImages) === 'undefined') {
        gamedata.uploadedImages = [];
      }
      gamedata.uploadedImages.push(image);
    }
  },
  computed:{
    isImageMode: {
      get() {
        return !this.component.anim;
      },
      set(nv) {
        if (nv) {
          console.log('set image mode', nv);
          this.$set(this.vfg.schema.data.component, 'anim', false);
        }
      }
    },
    isAnimationMode: {
      get() {
        return !!this.component.anim;
      },
      set(nv) {
        if (nv) {
          console.log('set animation mode', nv);
          this.$set(this.vfg.schema.data.component, 'anim', true);
        }
      }
    },
    imageUrl() {
      return this.api.makeImageUrlEditor(this.value);
    },
    sizeClass() {
      if (this.schema.spriteSize) {
        return ['h-' + this.schema.spriteSize];
      } else {
        return ['h-32'];
      }
    },
    isAtlas() {
      const {component} = this.vfg.schema.data;
      return !!component.atlas;
    },
    component() {
      const {component} = this.vfg.schema.data;
      return component;
    }
  },
  components: {
    ChooseOrUploadImage,
    ChooseOrUploadAnimations,
    SpriteView
  }
}
</script>
